export const environment: { [key: string]: string } = {
  apiUrl: process.env["REACT_APP_API_URL"] as string | "",
};
